import { CLASSES } from '../_consts';

export default function sidebarToggle() {

  const sidebarBtn = document.querySelector('.js-toggle-sidebar');
  const sidebar = document.querySelector('.js-sidebar');

  if (sidebarBtn) {
    sidebarBtn.addEventListener('click', (e) => {
      e.preventDefault();
      sidebar.classList.toggle(CLASSES.isActive);
    })
  }


}
